var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormDatePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88889 6.11111V3M13.1111 6.11111V3M6.11111 9.22222H13.8889M4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V6.11111C17 5.252 16.3036 4.55556 15.4444 4.55556H4.55556C3.69645 4.55556 3 5.252 3 6.11111V15.4444C3 16.3036 3.69645 17 4.55556 17Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDatePlaceholder);
export default __webpack_public_path__ + "static/media/form-date-placeholder.6aa18aabd9725cce54175b40264fffdd.svg";
export { ForwardRef as ReactComponent };